import { HTTP } from './helpers/http.js'
export default {
  create(args = {}) {
    const { organizationId, accounts } = args
    const data = {
      operation: 'post',
      data: accounts,
    }
    const url = `/api/v1/organizations/${organizationId}/accounts/bulk-operations`
    return HTTP.post(url, data)
  },
}
